export class IAddToCartResponse {
  code: number;
  message: string;
}
